import React, { useEffect, useState } from 'react';

type TConditionalRender = {
    children: React.ReactNode;
    condition?: boolean;
    delay?: number;
};

const ConditionalRender = ({ condition, children, delay }: TConditionalRender) => {
    const [isDelayPassed, setIsDelayPassed] = useState(false);

    useEffect(() => {
        if (condition && delay) {
            const timer = setTimeout(() => {
                setIsDelayPassed(true);
            }, delay);

            return () => {
                clearTimeout(timer);
                setIsDelayPassed(false);
            };
        }
    }, [condition, delay]);

    const shouldRender = condition && (!delay || isDelayPassed);

    return shouldRender ? children : null;
};

export { ConditionalRender };
